"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Collections = void 0;
const client_1 = require("@arkecosystem/client");
class Collections extends client_1.Resource {
    async all(query) {
        return this.sendGet("nft/collections", query);
    }
    async get(id) {
        return this.sendGet(`nft/collections/${id}`);
    }
    async getSchema(id) {
        return this.sendGet(`nft/collections/${id}/schema`);
    }
    async wallet(id) {
        return this.sendGet(`nft/collections/${id}/wallets`);
    }
    async searchByCollections(payload, query) {
        return this.sendPost("nft/collections/search", payload, query);
    }
    async assetByCollectionId(id, query) {
        return this.sendGet(`nft/collections/${id}/assets`, query);
    }
}
exports.Collections = Collections;
//# sourceMappingURL=collections.js.map